<script>
    import { router } from 'tinro';
    import { createEventDispatcher } from 'svelte';

    export let focusedIndex;
    export let navigation;

    const dispatch = createEventDispatcher();

    $: if (typeof focusedIndex !== 'undefined') {
        dispatch('focusMenuItem', focusedIndex);
    }

    function focusMenuItem(index) {
        const menuItem = document.getElementById(navigation[index % navigation.length].id);
        menuItem.focus();
    }
</script>

<nav id="databases-navigation" aria-label="PCC Databases Directory" on:focusMenuItem="{(event) => focusMenuItem(event.detail)}">
    <ul role="tablist" class="d-flex flex-column justify-content-between flex-md-row justify-content-md-start">
        {#each navigation as menuitem, index}
            <li class="border-md-right">
                <a role="tab"
                   tabindex="{index === 0 ? 0 : -1}"
                   id="{menuitem.id}"
                   href="{menuitem.path}"
                   class="nav-item keynav"
                   class:active="{$router.path === menuitem.path}"
                   aria-selected="{index === 0}"
                   aria-controls="{menuitem.id}-content"
                   data-index="{index}"
                >{menuitem.label}</a>
            </li>
        {/each}
    </ul>
    <span class="sr-only">Use arrows to navigate tabs</span>
</nav>